import { render, staticRenderFns } from "./market-order.vue?vue&type=template&id=c4c78e28&scoped=true&"
import script from "./market-order.vue?vue&type=script&lang=js&"
export * from "./market-order.vue?vue&type=script&lang=js&"
import style0 from "./market-order.vue?vue&type=style&index=0&id=c4c78e28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c78e28",
  null
  
)

export default component.exports